module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA8CAYAAAAt3km7AAAABHNCSVQICAgIfAhkiAAAATVJREFUaIHt2lFygjAURuET9sDIboorU1fWuBs7LII+NHekrUUEUvgz97yREc0317wlMKhraOk5pccWlQIXgPrG+b6U6g68o4R5VOBiuADQNZwHk1Iv1h8cQ2GorwLHaus9ZKnnFLoD/db7yFAsFUaZf0UcppfD1HKYWg5Ty2FqOUwth6nlMLUcppbD1HKYWg5Ty2FqOUwth6nlMLWKhsWtN5GhWObEAtfKruuUVlXfiEXh0rWj+12qEm7o/LxLZQnjYkJFWwiPPiUFHEzp+/JIOwf+mtKwURgkHLAj4CjIegqzdjC9SSBrMszaBPjHORp/ZWb/BHxpSsNmwyDr+ZsNshbBrBWntxhkrQKzFgFnnKPxr8vQi8DVpjQsCwwmnb8sICsbzOoaWqCl5y394hWIuUDF9wnkDG7oo9vBSgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(11).png
// module id = bPCe
// module chunks = 1